<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1 m-2">
				<div class="">
					<div v-if="loading" class="">
						Loading...
					</div>
					<div v-else-if="!order.orders" class="">
						Not Found!
					</div>
					<div v-else>
						<div class="">
							<div class="flex items-center justify-between pb-4 mb-4 border-b-2">
								<div class="">
									<h2>Order</h2>
									<h1 class="text-gray-700 text-2xl sm:text-5xl mb-5 leading-none">
										{{ ordernumber }}
									</h1>
									<h4>
										{{ supplier }}<br>
										<span :title="created_at">{{ daysFrom(created_at) }}</span>
									</h4>
								</div>
								<div class="text-right">
									<h1 class="text-gray-700 text-xl sm:text-3xl mb-5 uppercase inline-block px-2 py-1" :class="`${status}Class`">
										{{ status }}
									</h1>
									<div class="flex space-x-2 items-center cursor-pointer" @click="changeSupplier = true">
										<repeat-icon class="w-4" title="change supplier"></repeat-icon> <span>Change Supplier</span>
									</div>
								</div>
							</div>
							<!-- Comments -->
							<div class="w-full">
								<div class="flex items-start text-sm rounded py-1 mt-2" v-for="comment in order_comments" :key="comment.id">
									<div class="hidden w-10 h-10 rounded-full bg-gray-400 mr-2"></div>
									<div class="flex-1">
										<div class="flex items-center text-right">
											<div class="text-blue-500 font-bold mr-2">
												{{comment.username}}
											</div>
											<div class="text-xs text-gray-500">{{ daysFrom(comment.created_at) }}</div>									
										</div>
										<div class="flex-1">{{comment.comment}}</div>
									</div>
								</div>
								<div class="flex flex-wrap justify-between">
									<div class="w-full mb-4 sm:mb-0 sm:w-auto">
										<div class="" v-if="status!='complete'">
											<a class="italic text-right text-sm text-blue-600 cursor-pointer" v-if="!addJobComment" @click="addJobComment=!addJobComment">
												<span>add comment</span>
											</a>
										</div>
										<div class="text-right" v-if="addJobComment">
											<textarea class="bg-white rounded border border-gray-200 w-full p-1" v-model="order_comment" name="" id="" cols="30" rows="3" placeholder="comment"></textarea>
											<div class="link inline-block mr-2 cursor-pointer" @click="addJobComment=!addJobComment">cancel</div>
											<div class="btn btn-blue inline-block cursor-pointer" @click="postComment">post</div>
										</div>										
									</div>
									<div class="w-full sm:w-auto">
										<div class="text-right" v-if="status=='ordered' && canReceive">
											<input class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" v-model="order_invoice" name="" id="" type="text" placeholder="Invoice Number">
										</div>
										<div class="font-bold text-black" v-else>
											Invoice numbers
										</div>
										<div class="text-right break-words" v-for="invNumber in invoiceNumbers">
											{{ invNumber }}
										</div>
									</div>
								</div>
							</div>
							<div class="flex text-sm px-2 py-1 bg-gray-600 text-gray-200 mt-6">
								<div class="flex-1">
									product
								</div>
								<!-- <div class="hidden sm:block sm:w-48">
									description
								</div> -->
								<div class="w-48" v-if="status!='ordered' && canReceive">
									invoice#
								</div>
								<div class="w-16 text-center">
									delivered
								</div>
								<div class="w-16 text-center">
									ordered
								</div>
								<div class="w-32">
									price
								</div>
								<div class="w-32">
									total
								</div>
								<div class="w-32 text-right">
									received
								</div>
								<div class="w-16">
									&nbsp;
								</div>
							</div>
							<div class="hidden ml-2 text-right sm:block sm:w-24 sm:text-left">

							</div>
							<div class="py-2">
								<div class="" v-for="product in order.orders" :key="product.id">
									<!-- <div class="text-black px-2 mb-2">{{ categoryByKey(key) }}</div> -->
									<div class="flex flex-wrap items-center px-2 py-2 border-b font-bold text-sm">
										<div class="flex-1 text-black flex items-center">
											{{ product.name }} <span class="text-sm" v-if="product.pack_size > 0">{{ product.description }}</span> <span class="text-white">{{ product.id }}</span>
										</div>
										<!-- <div class="w-full order-last sm:w-48 sm:order-none">
											{{ product.description }}
										</div> -->
										<div class="w-48 break-words" v-if="status!='ordered' && canReceive">
											<input type="text" class="form-input text-lg w-full p-1 border-blue-400 text-black" v-model="orderStatus[product.forecast_order_id].pdtinvoice" v-if="product.received_qty != product.ordered_qty" @input="updateReceived(product.forecast_order_id, product.invoiceno,$event,'invoiceno')">
											<div v-else>
												<p v-for="invnumber in product.invoiceno">
													{{ invnumber }}
												</p>
											</div>
										</div>
										<div class="w-16 text-center">
											{{ product.received_qty }}
										</div>
										<div class="w-16 text-center font-bold text-lg text-black">
											{{ product.ordered_qty }}
										</div>
										<div class="relative z-10 w-32 flex space-x-2 items-center " :class="[changePrice.includes(product.id) ? 'w-64' : '']">
											<div class="flex items-center space-x-1" v-if="changePrice.includes(product.id)">
												<div class="">
													<input :id="`price-${product.id}`" type="text" class="w-20" :value="product.price / 100">
												</div>
												<action-button class="flex justify-center text-green-600 bg-white p-1 rounded shadow hover:bg-green-100" @button-clicked="saveNewPrice(product.id, product.forecast_order_id)">
													<save-icon class="w-4 h-4"></save-icon>
												</action-button>
											</div>
											<p v-else>{{ (product.price/100) | toCurrency }}</p>
											<button class="underline text-sm" @click="toggleChangePrice(product.id)" v-text="changePrice.includes(product.id) ? 'cancel' : 'change'" v-if="isAdmin"></button>
										</div>
										<div class="relative w-32" v-if="! changePrice.includes(product.id)">
											{{ (product.price * product.pack_size * product.ordered_qty)/100 | toCurrency }}
										</div>
										<div class="w-32 text-right" v-if="status !== 'complete'">
											<input type="text" class="form-input text-lg w-full text-right p-1 mx-auto border-blue-400" v-if="canReceive && product.ordered_qty!=product.received_qty" v-model="orderStatus[product.forecast_order_id].amount">
											<span v-else-if="product.ordered_qty ==product.received_qty">
												<check-circle-icon class="inline-block w-4 h-4 text-green-500"></check-circle-icon>
											</span>
										</div>
										<div class="w-16">
											<label :for="`firstfix_${product.forecast_order_id}`">
												<input type="checkbox" class="form-checkbox h-6 w-6 ml-3 border-blue-400" :id="`firstfix_${product.forecast_order_id}`"  v-if="canReceive && product.ordered_qty!=product.received_qty" :name="`firstfix_${product.forecast_order_id}`" @change.self="ToggleFirstFixPdtQty($event, product.forecast_order_id, product.ordered_qty, product.received_qty)">
											</label>
										</div>
										<div class="w-full mt-1">
											<div class="text-sm rounded" v-for="comment in product.comments" :key="comment.id">
												<div class="flex-1 group">
													{{comment.comment}} --
													<span class="inline-block text-blue-500 font-bold mr-2">
														{{comment.username}}
													</span>
													<span class="text-xs text-gray-500">{{ daysFrom(comment.created_at) }}</span>
													<a class="hidden cursor-pointer italic text-right text-sm text-blue-600 group-hover:inline" v-if="canComment" @click="addOrderComment(product.forecast_order_id)">
														... reply
													</a>
												</div>
											</div>
											<div class="text-right" v-if="(orderStatus[product.forecast_order_id].amount !== null && (Number(orderStatus[product.forecast_order_id].amount) + Number(product.received_qty) != product.ordered_qty))">
												<input-hidden name="productId" :value="product.id"/>
												<textarea class="bg-white rounded border border-gray-200 w-full p-1" name="" id="" cols="30" rows="3" placeholder="comment" @input="updateReceived(product.forecast_order_id, product.ordered_qty,$event,'new_comment')">
												</textarea>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="py-1 text-right mt-8" v-if="transport_cost>0"><h4>Transport Cost: {{ transport_cost | toCurrency }}</h4></div>
							<div class="py-1 text-right" :class="(transport_cost>0)?'':'mt-8'"><h4>sub-total: {{ total_order_amt | toCurrency }}</h4></div>
							<div class="py-1 text-right border-b"><h4>vat: {{ total_vat | toCurrency }}</h4></div>
							<div class="py-2 text-right"><h3>Total: {{ total_amt | toCurrency }}</h3></div>
						</div>
					</div>
				</div>
		</div>
		<div class="mt-4 py-4" :class="hasError ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600'" v-if="(role=='Super Admin' || role=='Administrator' || role=='Head Office Storeman' || role=='Accounts') && status != 'received'">
			<action-button class="flex w-full justify-center text-white" @button-clicked="updateOrder" :disabled="hasError">
				<clipboard-icon class="w-5 h-5 mr-1"></clipboard-icon>
				<span>Update Order</span>
			</action-button>
		</div>
		<portal to="modals" v-if="changeSupplier" :order="1">
			<change-supplier-modal
				:show="changeSupplier"
				:orderNumber="$route.params.orderrefid"
				:order="order.orders"
				@close="changeSupplier = ! changeSupplier"
				@save="saveChangeSupplier"
				@reload="$emit('reload')"
				>
			</change-supplier-modal>
		</portal>
	</div>
</template>

<script>
	import {formatDistance, parseISO} from 'date-fns';
	import {MessageSquareIcon, RepeatIcon} from 'vue-feather-icons';
	import InputHidden from '../../components/common/InputHidden.vue'
	import ChangeSupplierModal from '../../components/common/ChangeSupplierModal.vue'
	export default {
		name: 'ForecastOrderDetail',
		data () {
			return {
				addJobComment: false,
				changeSupplier: false,
				supplier: null,
				supplier_id: null,
				created_at: null,
				order_comment: '',
				order_invoice: '',
				invoiceNumbers: [],
				recieved: [],
				order: {},
				order_comments: {},
				loading: true,
                orderStatus: [],
				reference_id:'',
				ordernumber:'',
				ct:0,
				status:'',
				transport_cost:0,
				changePrice:[],
			}
		},
		computed: {
			fetchUrl: function(){
				return `forecastorders/${this.$route.params.orderrefid}`
			},
			jobName: function(){
				return this.$store.getters.jobName || "Job Name";
			},
			isAdmin: function(){
				return this.role == 'Super Admin' || this.role == 'Administrator' || this.role == 'Accounts';
			},
			role: function(){
				return this.$store.getters['auth/role'];
			},
			total_order_amt: function(){
				let total = this.order.orders.reduce((a, b) => a + (b.price * b.ordered_qty * b.pack_size), 0);
				return total/100;
			},
			total_vat: function(){
				return (this.total_order_amt / 100) * 15;
			},
			total_amt: function(){
				return this.total_order_amt + this.total_vat + this.transport_cost;
			},
      		isReceived: function() {
				return Object.keys(this.order).length && this.status == 'received'
			},
			canReceive: function(){
				return this.role=='Administrator' || this.role=='Accounts' || this.role=='Super Admin' || this.role=='Head Office Storeman'
			},
			canComment: function(){
				return this.role=='Administrator' || this.role=='Accounts' || this.role=='Super Admin' || this.role=='Head Office Storeman'
			},
			hasError: function(){
				// let err = false;
				// for (var key in this.orderStatus) {
				// 	if (this.orderStatus.hasOwnProperty(key)) {
				// 		if(((Number(this.orderStatus[key].ordered) - Number(this.orderStatus[key].received)) != Number(this.orderStatus[key].amount)) && !this.orderStatus[key].new_comment){
				// 			err =  true;
				// 			break;
				// 		}
				// 	}
				// }
				// return err;
				return false;
			}
		},
		components: {
			InputHidden,
			MessageSquareIcon,
			RepeatIcon,
			ChangeSupplierModal
		},
		methods: {
			toggleChangePrice: function(productId){
				let theIndex = this.changePrice.indexOf(productId);
				if(theIndex == -1){
					this.changePrice.push(productId);
					return;
				}
				this.changePrice.splice(theIndex, 1);
			},
			saveNewPrice: function(productId, forcastIds){
				let price = document.getElementById(`price-${productId}`).value;
				this.$http.post(`/forecastorders/price/update`, {
						forecast_ids: forcastIds,
						price: price,
						supplier_id: this.supplier_id,
					})
					.then(response => {
						let success = {
							title: 'Success',
							message: response.data.message,
							type: 'success'
						}
						this.changePrice = [];
						this.$store.commit('setStatus', success)		
						this.loadViewData();
					});
			},
			saveChangeSupplier: function(order, orderNumber){
				this.$http.post(`/forecastorders/${this.$route.params.orderrefid}/change_forecastorder_supplier`, {'order':order})
					.then(response => {
						let success = {
							title: 'Change suppliers successful',
							type: 'success'
						}
						this.$store.commit('setStatus', success)
					})
					.catch(error => {
						let err = {
							title: 'Server responded with a ' + error.response.status,
							message: error.response.data.message,
							type: 'error'
						}
						this.$store.commit('setStatus', err)
					})
					.finally(() => {
						this.loadViewData();
					})
			},
			pad: function(n, width, z){
				z = z || '0';
				n = n + '';
				return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
			},
			categoryByKey: function(key){
				return this.$store.getters.getProductCategoryNameByKey(key);
			},
			daysFrom: function(dateString){
				return formatDistance(Date.parse(dateString, 'yyyy-MM-dd HH:mm:ss', new Date()), new Date(), { addSuffix: true });
			},
			updateReceived: function(id, ordered, event,loc){
				this.orderStatus[id][loc] = event.target.value;
			},
			addOrderComment: function(id){
				if(this.orderStatus[id].new_comment === ''){
					this.$delete(this.orderStatus[id], 'new_comment');
				}
				if(this.orderStatus[id]){
					this.$set(this.orderStatus[id], 'new_comment', '');
				}
			},
			postComment: function(){
				// console.log(this.order_comment)
				this.$http.post(`forecastorders/${this.$route.params.orderrefid}/comment`, {'order_comment':this.order_comment,'user_id':this.$store.getters['auth/userid']})
					.then(response => {
						this.loadViewData();
						let success = {
							title: 'Comment added',
							type: 'success'
						}
						this.$store.commit('setStatus', success)
					})
					.catch(error => {
						let err = {
							title: 'Server responded with a ' + error.response.status,
							message: error.response.data.message,
							type: 'error'
						}
						this.$store.commit('setStatus', err)
					})
					.finally(() => {
						this.addJobComment = false;
						this.order_comment = '';
					})
			},
			updateOrder: function(){
				if(this.order_invoice == '' && this.status=='ordered'){
					let err = {
						title: 'Invoice number is required',
						message: '',
						type: 'error'
					}
					this.$store.commit('setStatus', err)
					return;
				}
				this.$http.post(`forecastorders/${this.$route.params.orderrefid}/verify/`, {
					'products':this.orderStatus,
					'order_invoice':this.order_invoice,
					'user_id':this.$store.getters['auth/userid'],
					'ordernumber':this.ordernumber,
				})
					.then(response => {
						// this.$store.commit('order/emptyStore');	
						let success = {
							title: 'Success',
							message: 'Order Updated',
							type: 'success'
						}
						this.$store.commit('setStatus', success)
						this.$router.push(`/forecastorders`);
					})
					.catch(err => {
						let error = {
							title: 'Server Error',
							message: 'Please contact Roark, page is stock receiving',
							type: 'error'
						}
						this.$store.commit('setStatus', error);
					})
				},
				ToggleFirstFixPdtQty: function(event, forcast, orderQty, recQty){
					if(event.target.checked)
					this.orderStatus[forcast].amount = orderQty-recQty;
					else
					this.orderStatus[forcast].amount = null;
			},
			loadViewData: function(){
				this.reference_id = this.$route.params.orderrefid;
				this.$http.get(this.fetchUrl)
				.then(response => {
					this.order = response.data
					this.supplier = response.data.supplier
					this.supplier_id = response.data.supplier_id
					this.created_at = response.data.created_at
					this.ordernumber = response.data.ordernumber
					this.order_comments = response.data.order_comments
					this.status = response.data.orderstatus
					this.transport_cost = response.data.transport_cost
					let orderStatus = {};
					Object.keys(this.order.orders).forEach((key) => {
						this.order.orders[key].invoiceno.forEach(invno => {
							this.invoiceNumbers.push(invno);	
						});
	                    orderStatus[this.order.orders[key].forecast_order_id] = {
	                        'id': this.order.orders[key].forecast_order_id,
	                        'product_id': this.order.orders[key].id,
	                        'ordered': this.order.orders[key].ordered_qty,
	                        'received': this.order.orders[key].received_qty,
	                        'amount': null,
	                        'new_comment': null,
	                        'pdtinvoice': '',
	                        'comments': this.order.orders[key].comments
	                    };
					});
					this.orderStatus = Object.assign({}, this.orderStatus, orderStatus);
					this.invoiceNumbers = [...new Set(this.invoiceNumbers)];
					//console.log(this.orderStatus);
				})
				.catch(error => {
					console.log(error);
					let err = {
						title: 'Server responded with a ' + error.response.status,
						message: error.response.data.message,
						type: 'error'
					}
					// this.$store.commit('setStatus', err)
				}).then(()=>{
					this.loading = false
				})
			}
		},
		created () {
            this.loadViewData();
		}
	}
</script>
<style lang="css" scoped>
	.orderedClass {
		@apply rounded-full bg-red-400 text-white;
	}
	.processingClass {
		@apply border-2 rounded-full border-red-400 text-red-400;
	}
	.problemClass {
		@apply border-2 rounded-full border-yellow-500 text-yellow-700;
	}
	.receivedClass {
		@apply rounded-full bg-green-500 text-white;
	}
	.completeClass {
		@apply rounded-full bg-gray-300 text-white;
	}
</style>